import * as React from 'react';
import { CountDisplay, CountDisplayProps } from './Count/CountDisplay';
import { ItemsPerPage, ItemsPerPageProps } from './ItemsPerPage/ItemsPerPage';
import { Pagination, PaginationProps } from './Pagination/Pagination';

export interface ControlBarProps {
    /**
     * Props for the CountDisplay componeent
     */
    countDisplay: CountDisplayProps;
    /**
     * Props for the ItemsPerPage component
     */
    itemsPerPage: ItemsPerPageProps;
    /**
     * Props for the Pagination component
     */
    pagination: PaginationProps;
}

/**
 * This component represents
 * @param props Component props
 */
export function ControlBar(props: ControlBarProps) {
    return (
        <div className="simple-data-table-info copia_color1_b">
            <ItemsPerPage {...props.itemsPerPage} />
            <Pagination {...props.pagination} />
            <CountDisplay {...props.countDisplay} />
        </div>
    );
}
